import { db } from "@/lib/firebase";
import { doc, updateDoc } from "firebase/firestore"; 

export const markNotificationAsRead = async (id: string) => {
  try {
    const ref = doc(db, "notifications", id);

    await updateDoc(ref, {
      is_read: true,
    });
  } catch (err) {
    console.error("Error marking as read:", err);
  }
};
